import React from 'react';
import { FlownBookingsLists } from 'acscp/components/bookings/flownBookingsLists';
import { PageHeader } from 'acscp/components/common/pageHeader';
import { withPageLayout } from 'acscp/components/layout/pageLayout';
import { FormattedMessage } from 'react-intl';
import style from 'acscp/components/bookings/bookingsLists.module.scss';

const FlownBookingsListPagePresentational: React.SFC = () => {
    return (
        <div className={style.ExpandAllParentDiv}>
            <PageHeader
                title={
                    <FormattedMessage
                        id={'components.pages.bookingsList.title'}
                        defaultMessage={'MY CHARTERS'}
                    />
                }
            />
            <FlownBookingsLists />
        </div>
    );
};

const FlownBookingsList = withPageLayout(FlownBookingsListPagePresentational);
export { FlownBookingsList, FlownBookingsListPagePresentational };
